import React from "react";
import styles from './ActionsLayout.module.scss'
import Button from "../../../../components/ripple/Button";

import { URL_CONSULT_DEPLOYMENT } from "../../../../settings/content/linksExternal";

function ActionsLayout({
                           nextTitle,
                           nextDisabled,
                           nextIcon,
                           nextForm,
                           nextType,
                           prevTitle,
                           prevDisabled,
                           prevIconRight,
                           prevIconLeft,
                           prevForm,
                           prevType,
                           prevDisplayType,
                           disabledGlobal,
                           loading,
                           nextOnClick,
                           prevOnClick,
                           margin,
                       }) {
    return (
        <div
            className={styles.buttons}
            style={{
                ...(margin ? {margin: margin} : {}),
            }}
        >
            {
                (
                    prevTitle
                    || prevIconRight
                    || prevIconLeft
                    || prevForm
                    || prevType
                ) &&
                <div className={styles.buttons__left}>
                    <Button
                        className={styles.buttons__left__button}
                        form={prevForm}
                        iconRight={prevIconRight ? loading ? 'fas fa-spinner fa-spin' : prevIconRight : undefined}
                        iconLeft={prevIconLeft ? loading ? 'fas fa-spinner fa-spin' : prevIconLeft : undefined}
                        title={prevTitle}
                        displayType={prevDisplayType || 'text'}
                        visuals={{height: '5rem', borderRadius: '25px'}}
                        disabled={prevDisabled || disabledGlobal}
                        type={prevType || 'button'}
                        onClick={prevOnClick}
                    />
                </div>
            }
            <a
                className={styles.buttons__support}
                href={URL_CONSULT_DEPLOYMENT}
                target='_blank'
                draggable='false'
                tabIndex='-1'
            >
                <Button
                    displayType='text'
                    className={styles.buttons__support__button}
                    form='deployment-form'
                    iconLeft='fas fa-headset'
                    title='Deploy with the help of tech consultant'
                    visuals={{height: '5rem', borderRadius: '25px'}}
                />
            </a>
            <Button
                className={styles.buttons__deploy}
                form={nextForm}
                iconRight={loading ? 'fas fa-spinner fa-spin' : nextIcon}
                title={nextTitle}
                visuals={{height: '5rem', borderRadius: '25px'}}
                disabled={nextDisabled || disabledGlobal}
                type={nextType || 'button'}
                onClick={nextOnClick}
            />
        </div>
    );
}

export default ActionsLayout